import urls from './config.json'

const config =  () => {
    if(window.location.href.includes('dispatcher.unrealsoft.bg')){
        return urls.PRODUCTION
    }
    if(window.location.href.includes('dispatcherdev.unrealsoft.bg')){
        return urls.DEVELOPMENT
    }
    if(window.location.href.includes('dispatcher2.unrealsoft.bg')){
        return urls.PRODUCTION_DOCKER
    }

    return urls.LOCAL
};

export const apiURl = config()